import _typeof from "@babel/runtime/helpers/esm/typeof";
import { StatusMessage } from '@s7/ui-kit';
import React from 'react';
import styles from './Notification.css';
import classNames from 'classnames/bind';
var cx = classNames.bind(styles);
export var Notification = function Notification(_ref) {
  var notification = _ref.notification;
  return notification && _typeof(notification) === 'object' ? /*#__PURE__*/React.createElement("div", {
    className: cx('notification')
  }, /*#__PURE__*/React.createElement(StatusMessage, notification)) : null;
};